import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import useToast from "../hooks/useToast";
import ErrorBoundary from "./ErrorBoundary";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Button from "../components/Button";
import { Helmet } from "react-helmet";
import { SkeletonTheme } from "react-loading-skeleton";
import { isMobile } from "react-device-detect";
import classNames from "classnames";
import { WinterMode } from "../utils/Network";
import { Snowfall } from "react-snowfall";
import { useAppTranslation } from "../i18n/useAppTranslation";

type Props = {
  children: React.ReactNode;
};

const AuthLayout = ({ children }: Props) => {
  const { t } = useAppTranslation(["auth"]);
  const searchParams = useSearchParams();
  const openToast = useToast();
  const snowflakeImage = new Image();
  snowflakeImage.src = "/assets/images/icons/cherry-blossom-3.svg";
  const snowflakeImage2 = new Image();
  snowflakeImage2.src = "/assets/images/icons/cherry-blossom.svg";
  return (
    <SkeletonTheme
      enableAnimation={!isMobile}
      // baseColor="#3e382b"
      // highlightColor="#474132"
            baseColor="#3e382b"
      highlightColor="#474132"
    >
      <Helmet>
        <script src="https://www.google.com/recaptcha/api.js?render=6LfdbIYoAAAAACravcE9SShwtp3LI7EMz5rH4gMa"></script>
      </Helmet>
      {/* <HolloweenBoard/> */}
      <Navbar
        sticky="top"
        expand="lg"
        className="transparent w-100 position-absolute"
      >
        <Container>
          <a href="https://chainoflegends.com">
            <Navbar.Text className="text-white d-flex align-items-center text-shadow bold">
              <img
                width={33}
                className="me-2"
                src="/assets/images/icons/home.png"
              />
              {t("auth:layout.backToSite")}
            </Navbar.Text>
          </a>
          <div className="d-none d-md-block logo-auth">
            <img width={60} src="/assets/images/chainoflegends-logo.png" />
          </div>
          <div>
            <a target="_blank" href="https://whitepaper.chainoflegends.com">
              <Button variant="wide" className="px-1">
                <img
                  width={20}
                  className="me-2"
                  src="/assets/images/icons/whitepaper.png"
                />
                {t("auth:layout.whitepaper")}
              </Button>
            </a>
          </div>
        </Container>
      </Navbar>
      <div
        className={classNames(
          "main-layout pb-5 p-relative flex-column justify-content-center d-flex align-items-center pt-5",
          {
            winter: WinterMode,
          }
        )}
      >
        <ErrorBoundary openToast={openToast}>

          {children}
        </ErrorBoundary>
      </div>
    </SkeletonTheme>
  );
};

export default AuthLayout;
